import validator from "validator";
import { CreateUserPayload } from "../../types/user/user-payload";

export const validateUserPayload = (
  createProUserPayload: CreateUserPayload
) => {
  const name = validator.isEmpty(createProUserPayload.name);
  const phone =
    !validator.isNumeric(createProUserPayload.phone) ||
    !validator.isLength(createProUserPayload.phone, {
      min: 11,
      max: 11,
    });
  const role = false;
  const birth = !validator.isDate(createProUserPayload.birth, {
    format: "YYYY-MM-DD",
  });
  const username = validator.isEmpty(createProUserPayload.username);
  const password = validator.isEmpty(createProUserPayload.password);
  const parkinglot = false;
  const scheduleAlias = validator.isEmpty(createProUserPayload.scheduleAlias);
  const appViewMode = false;
  const companyId = validator.isEmpty(createProUserPayload.companyId);

  return {
    hasError:
      name ||
      phone ||
      role ||
      birth ||
      username ||
      password ||
      parkinglot ||
      scheduleAlias ||
      appViewMode ||
      companyId,
    validationResults: {
      name,
      phone,
      role,
      birth,
      username,
      password,
      parkinglot,
      scheduleAlias,
      appViewMode,
      companyId,
    },
  };
};
